import {
  BasisActions,
  BasisState,
  CalendarActions,
  CalendarState,
} from '@raskrask-dk/bookingflow-state-machine'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { BasisTypeBF } from '../../../models'
import { useBFSMValue } from '../../../services/hooks/useBFSMValues'
import { PropsInformationTemplate } from './props'
import BookingInformationTemplate from './template'

const BookingInformationPage = (): ReactElement => {
  const { t } = useTranslation()

  const [basisType] = useBFSMValue<
    BasisState,
    BasisActions.SetBasisType,
    'basisType'
  >('basisType')
  const [date] = useBFSMValue<CalendarState, CalendarActions.SetDate, 'date'>(
    'date'
  )
  const [goal] = useBFSMValue<CalendarState, CalendarActions.SetGoal, 'goal'>(
    'goal'
  )
  const [partner] = useBFSMValue<
    CalendarState,
    CalendarActions.SetPartner,
    'partner'
  >('partner')
  const [serviceType] = useBFSMValue<
    CalendarState,
    CalendarActions.SetServiceType,
    'serviceType'
  >('serviceType')
  const [time] = useBFSMValue<CalendarState, CalendarActions.SetTime, 'time'>(
    'time'
  )

  const bookInformations: PropsInformationTemplate[] = [
    { preText: t('common:date'), postText: date!.toString('dd/MM/yyyy') },
    { preText: t('common:time'), postText: time! },
    {
      preText: t(`common:basistypes.${basisType!.id}.singularis`),
      postText: partner!.alias,
    },
  ]

  return (
    <BookingInformationTemplate
      goalName={t(`common:goals.${goal!.id}`)}
      icon={(basisType as BasisTypeBF).icon}
      informations={bookInformations}
      serviceLength={`${serviceType!.duration.toMillis() / 60 / 1000
        } min`}
    />
  )
}

export default BookingInformationPage
